export function cleanAssistantText(value) {
  return String(value || "")
    .replace(/\n{1,3}\s*(?:\*\*)?\s*catatan\s+validasi\s+file\s+mentah\s*:\s*(?:\*\*)?[\s\S]*$/i, "")
    .replace(/\s+catatan\s+validasi\s+file\s+mentah\s*:\s*[\s\S]*$/i, "")
    .replace(/\*\*([^*\n]+)\*\*/g, "$1")
    .replace(/(^|[\s([{])\*([^*\n]+)\*(?=($|[\s)\]},.;:!?]))/g, "$1$2")
    .replace(/```[a-z0-9_-]*\n?([\s\S]*?)```/gi, "$1")
    .replace(/`([^`\n]+)`/g, "$1")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^[ \t]*[•▪■□☐☑☒][ \t]*/gm, "- ")
    .replace(/[☐☑☒]/g, "")
    .replace(/^[ \t]*[-*][ \t]+/gm, "- ")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}
